import React from 'react';
import { DefaultLayout } from '../layout/DefaultLayout';
import Header from '../components/molecules/Header';
import { useTranslate } from '@tolgee/react';
import { useAuth } from 'lincd-auth/lib/hooks/useAuth';
import { Player } from 'lincd-irlcg/lib/shapes/Player';
import { UserAccount } from 'profile-plus/lib/shapes/UserAccount';
import LatestActivity from '../components/molecules/LatestActivity';
import GameBoardStats from '../components/molecules/GameBoardStats';
import './LiveGameboard.scss';
import style from './LiveGameboard.scss.json';
import { asset } from 'lincd/lib/utils/LinkedFileStorage';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../routes';

interface LiveGameboardProps {
  live: boolean;
}

const LiveGameboard = ({ live = true }: LiveGameboardProps) => {
  const { t } = useTranslate();
  let prefix = 'liveGameboard';
  const auth = useAuth<Player, UserAccount>();
  const userAccount = auth.userAccount;
  const user = userAccount?.accountOf as Player;

  // get event uri from the query params
  const [searchParams] = useSearchParams();
  const eventUri = searchParams.get('eventUri');

  if (!userAccount && !eventUri) {
    return <Navigate to={ROUTES.register.path} replace />;
  }

  return (
    <DefaultLayout>
      <div className={style.container}>
        <>
          <div className={style.headerWrapper}>
            <img
              className={style.gearIcon}
              src={asset('/images/rotary_calgary.png')}
              alt="Rotary Calgary logo"
            />
            <Header
              title={t('word.GlobalGameBoard', 'Peace Gameboard')}
              inverted={true}
            />
            <div className={style.pgIcon}>
              <img
                src={asset('/images/poe_logo_clear@2x.png')}
                width="24px"
                height="24px"
                alt="globe"
              />
              <h3>Peace Game</h3>
            </div>
          </div>
          <div className={style.globeContainer}>
            <LatestActivity event={eventUri} />
          </div>
          <GameBoardStats eventUri={eventUri} />
        </>
      </div>
    </DefaultLayout>
  );
};

export default LiveGameboard;
